import axios from "axios";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const access_token  = getCookie("access_token")

// if (!access_token) {
//   console.error("Token de acceso no encontrado");
//   window.location.href = '/login';
// }

const url = process.env.REACT_APP_API;

const axiosInstanceToken = axios.create({
  baseURL: url,
  headers: {
    "authorization": `Bearer ${access_token}`,
  },
});

axiosInstanceToken.interceptors.request.use(config => {
  return config;
});

axiosInstanceToken.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error("Error en la respuesta de la API", error);
    if (error.response && error.response.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);


export { axiosInstanceToken };
